module.exports = __webpack_public_path__ + "static/media/intro-2@2x.1b5f6ed0.jpg";